import dayjs from "dayjs";

export default function formatDate(date = "") {
  if (!date) return " ";
  return dayjs(date, "YYYYMMDDHHmm").format("YYYY-MM-DD HH:mm");
}
